import { apiClient } from '../../../gateways/api'
import type { Project } from '../types/Project'

export { fetchProject }

const fetchProject = async ({ id }: { id: string }): Promise<Project> => {
  const { data } = await apiClient({
    url: `/rest/project/${id}`,
    method: 'GET',
  })

  return data
}
